/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UploadIcon = ({ width = 24, height = 24, hidden = false, title = 'Upload' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m13.52734,10.49121l-3.00244-2.99805c-.29297-.29297-.76709-.29297-1.06006,0l-2.99756,2.99805c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33838.21973.53027.21973s.38379-.07324.53027-.21973l1.72217-1.72217v8.18018c0,.41406.33594.75.75.75s.75-.33594.75-.75v-8.17285l1.71777,1.71484c.29297.29297.76758.29297,1.06055,0,.29248-.29297.29248-.76855-.00098-1.06055Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="m15.75,17h-2.79883c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h2.79883c.41357,0,.75-.33691.75-.75V4.25c0-.41309-.33643-.75-.75-.75H4.25c-.41357,0-.75.33691-.75.75v10.5c0,.41309.33643.75.75.75h2.72559c.41406,0,.75.33594.75.75s-.33594.75-.75.75h-2.72559c-1.24072,0-2.25-1.00977-2.25-2.25V4.25c0-1.24023,1.00928-2.25,2.25-2.25h11.5c1.24072,0,2.25,1.00977,2.25,2.25v10.5c0,1.24023-1.00928,2.25-2.25,2.25Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
